import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { devAPI } from '@/lib/api';

export default function UsagePage() {
  const { data: apps = [] } = useQuery({ queryKey: ['apps'], queryFn: () => devAPI.getApps() });
  const [appId, setAppId] = useState<string>('');
  useEffect(() => { if (!appId && apps.length) setAppId(apps[0].id); }, [apps, appId]);
  const { data: usage } = useQuery({ queryKey: ['usage', appId], queryFn: () => devAPI.getUsage(appId), enabled: !!appId });

  return (
    <div className="p-6 max-w-4xl">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Usage</h1>
      <p className="text-gray-600 mb-6">API requests attributed to each application (last 30 days).</p>
      <select value={appId} onChange={(e) => setAppId(e.target.value)} className="border border-gray-300 rounded-md px-3 py-2 mb-6">
        {apps.map((a: any) => <option key={a.id} value={a.id}>{a.name}</option>)}
      </select>
      {usage && (
        <div className="bg-white border border-gray-200 rounded-lg p-5">
          <p className="text-sm text-gray-600 mb-4">Total: <span className="font-semibold">{usage.total}</span> requests</p>
          <div style={{ height: 280 }}>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={usage.series}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" fontSize={11} />
                <YAxis fontSize={11} allowDecimals={false} />
                <Tooltip />
                <Line type="monotone" dataKey="value" stroke="#2563eb" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
          {usage.series.length === 0 && <p className="text-sm text-gray-500 mt-2">No usage yet — make some API calls with this app's keys.</p>}
        </div>
      )}
      {apps.length === 0 && <p className="text-gray-500">Create an application first.</p>}
    </div>
  );
}
